import React from 'react';
import Avatar from '../../components/Form/Avatar';
import UserInfo from '../../components/Form/UserInfo';
import StarRating from '../../components/Form/StarRating';

const ReviewCard = ({ profilePicture, userName, companyName, starRating, description }) => {
      // Get the first letter of the userName for the fallback profile picture

      return (
        <div className="w-full h-[196px] p-3 md:p-5 bg-[#FFFFFF] border border-[#0000000D] rounded-sm">
          <div className="grid-cols-1 lg:flex gap-4 lg:items-center lg:justify-between mb-3 lg:mb-8">
            <div className="flex items-center space-x-3">
              {/* Profile Picture or First Letter */}
              <Avatar
                profilePicture={profilePicture}
                userName={userName || 'Unknown User'}
                size={48}
              />
              {/* User Info */}
              <UserInfo
                userName={userName || 'Unknown User'}
                companyName={companyName || 'Unknown Company'} 
              />   
            </div>
            {/* Star Rating */}
            <div>
              <StarRating rating={starRating} size={20.145} loading={false} />
            </div>
          </div>
          {/* Description */}
          <p className="text-content-text font-inter text-level-7 lg:text-level-6 font-normal text-[#3E3E3E] line-clamp-4 leading-relaxed">
            {description || 'No description provided.'}
          </p>
        </div>
      );
    };

export default ReviewCard;